import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FilterGroup, ToggleSwitch, FilterLabel } from '@lt/components';
import styled from 'styled-components';
import {
  getToggleFilterInactiveItem,
  getToggleFilterActiveItem,
  getMinPrice,
  getHotelsCount,
} from '../../../utils/filtersUtils';
import RadioFilterGroup from './RadioFilterGroup';

const StyledFilterLabel = styled(FilterLabel)`
  * {
    white-space: normal;
  }
`;

const StyledSwitcherLabel = styled(StyledFilterLabel)`
  color: inherit;
`;

const ToggleFilterGroup = ({
  Filter,
  data,
  onChange,
  switcherIcon,
  labelIcon,
  labelOn,
  labelOff,
  isMobile,
  className,
  currencyCode,
}) => {
  const activeItem = getToggleFilterActiveItem(data);
  const inactiveItem = getToggleFilterInactiveItem(data);
  const { selected, disabled } = activeItem;
  const { filterName, filterLabel } = Filter;
  const totalCount = getHotelsCount(data);
  const minPrice = getMinPrice(data);

  const handleChange = useCallback(
    (isActive) =>
      onChange({ path: filterName, diff: { id: true, selected: isActive } }),
    [filterName, onChange],
  );

  if (isMobile) {
    const filters = [
      {
        ...activeItem,
        name: (
          <>
            <span>{labelOn}</span>
            {labelIcon}
          </>
        ),
        currencyCode,
      },
      {
        ...inactiveItem,
        name: labelOff,
        selected: !selected,
        hotel_count: totalCount,
        min_price: minPrice,
        currencyCode,
      },
    ];

    return (
      <RadioFilterGroup
        className={className}
        data={filters}
        Filter={Filter}
        LabelComponent={StyledFilterLabel}
        onChange={({ id }) => handleChange(id)}
        isMobile
      />
    );
  }

  return (
    <FilterGroup
      className={className}
      name={filterName}
      label={
        <div>
          <span>{filterLabel}</span>
          {labelIcon}
        </div>
      }
    >
      <ToggleSwitch
        id={`filter-${filterName}`}
        icon={switcherIcon}
        labelOn={
          <StyledSwitcherLabel
            count={activeItem.hotel_count}
            price={activeItem.min_price}
            currencyCode={currencyCode}
            name={labelOn}
            selected={selected}
          />
        }
        labelOff={
          <StyledSwitcherLabel
            count={totalCount}
            price={minPrice}
            currencyCode={currencyCode}
            name={labelOff}
            selected={!selected}
          />
        }
        selected={selected}
        disabled={disabled && !selected}
        onChange={handleChange}
      />
    </FilterGroup>
  );
};

ToggleFilterGroup.propTypes = {
  className: PropTypes.string,
  labelOn: PropTypes.string,
  labelOff: PropTypes.string,
  Filter: PropTypes.shape({
    filterName: PropTypes.string,
    filterLabel: PropTypes.string,
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currencyCode: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  switcherIcon: PropTypes.node,
  labelIcon: PropTypes.node,
  isMobile: PropTypes.bool,
};

ToggleFilterGroup.defaultProps = {
  className: '',
  labelOn: '',
  labelOff: 'Все туры',
  isMobile: false,
  switcherIcon: undefined,
  labelIcon: undefined,
};

export default React.memo(ToggleFilterGroup);
